module.exports = __webpack_public_path__ + "img/product-chuti-qt-09.872e7fa6.png";